import { gql } from '@apollo/client';

export const VERIFY_USER = gql`
  mutation verifyUser($email: String!) {
    updateUserVerified(email: $email)
  }
`;
